import LanguageCard from "../../layout-new-theme/LanguageCard";
import { useTranslation } from "react-i18next";
import {
  deletePaymentMethod,
} from "../../../actions/admin/flywire";
import { useState } from "react";
import ConfirmationModal from "../components/ConfirmationModal";
import { CloseIcon, BackAltIcon, RadioSelectedIcon, RadioUnselectedIcon, ArrowRightIcon } from "../../icons";


const visa_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/visa.svg";
const master_card_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/master-card.svg";
const jcb_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/jcb.svg";
const american_ex_icon = "https://newtlfbucket.s3.ap-northeast-1.amazonaws.com/revamp_ui_assets/icons/american_ex.svg";
const PaymentMethodSelectionModal = ({
  show,
  title,
  children,
  size = "",
  centered = false,
  onClose,
  paymentMethods,
  selectedPaymentMethod,
  handleSelectedPaymentMethod,
  payButtonAuthenticatedUser,
  quotationDetail,
  handleSetNewCard,
  handleDeleteCard,
  addPaymentMethodHandler
}) => {
  const { t } = useTranslation();

  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [toDeletePaymentMethodId, setToDeletePaymentMethodId] = useState(null);

  function getCardTypeByBrand(type) {
    if (type === "VISA") {
      return visa_icon;
    } else if (type === "MASTERCARD") {
      return master_card_icon;
    } else if (type === "AMERICAN EXPRESS") {
      return american_ex_icon;
    } else if (type === "JCB") {
      return jcb_icon;
    }

    return "Unknown"; // If none of the patterns match
  }

  const openShowModalDeleteConfirmation = async (paymentMethodId) => {
    try {
      setToDeletePaymentMethodId(paymentMethodId)
      setShowDeleteConfirmation(true);
    } catch (e) { }
  }


  const handleDeletePaymentMethod = async () => {
    try {
      const individualDetailId = quotationDetail?.user.individualDetail._id;
      const deletePayment = deletePaymentMethod(individualDetailId, toDeletePaymentMethodId);
      handleDeleteCard(toDeletePaymentMethodId);
      setShowDeleteConfirmation(false);

    } catch (e) { }
  }


  return (
    <>
      {!showDeleteConfirmation && <>
        <div className="d-none d-md-block">
          <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            style={show ? { backgroundColor: "rgba(0, 0, 0, 0.5)" } : {}}
            aria-labelledby="sharedModalLabel"
            aria-hidden={!show}
          >
            <div
              className={`modal-dialog ${size} ${centered ? "modal-dialog-centered" : ""
                }`}
            >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{title}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={onClose}
                  ></button>
                </div>
                {/* <div className="modal-body">{children}</div> */}
                <div className="modal-body ">
                  {paymentMethods != null && paymentMethods.length > 0 ? (
                    paymentMethods.map((item, index) => (
                      <div
                        className="p-3 rounded bg-F6F6F6 border-bottom-DBBE78 mb-3 pointer"
                        onClick={() => handleSelectedPaymentMethod(item._id)}
                      >
                        <div className="d-flex gap-2 align-items-center justify-content-start">
                          {selectedPaymentMethod === item._id
                            ? <RadioSelectedIcon />
                            : <RadioUnselectedIcon />}
                          <img
                            src={getCardTypeByBrand(item.brand)}
                            alt=""
                            srcSet=""
                          />
                          <p className="m-0">
                            •••• {item.cardNumber}, Exp.: {item.expirationMonth}/
                            {item.expirationYear}
                          </p>
                          <CloseIcon
                            color="#666666"
                            size={10}
                            className="ms-auto pointer"
                            onClick={() => openShowModalDeleteConfirmation(item._id)}
                          />
                        </div>
                      </div>
                    ))
                  ) : (
                    <p className="mb-3">
                      {t("PaymentMethodSelection.NoPayment")}
                    </p>
                  )}

                  <button
                    className="btn bg-gold-light-100 rounded py-2 mb-3 px-5"
                    onClick={addPaymentMethodHandler}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-2">
                      {t("PaymentMethodSelection.AddPayment")}
                    </div>
                  </button>

                  <div className="d-grid">
                    <button
                      className="btn bg-gold text-white rounded py-2"
                      onClick={() => {
                        if (
                          paymentMethods != null &&
                          paymentMethods.length > 0 &&
                          selectedPaymentMethod != null
                        ) {
                          payButtonAuthenticatedUser();
                        }
                      }}
                      disabled={
                        paymentMethods == null ||
                        paymentMethods.length < 1 ||
                        selectedPaymentMethod == null
                      }
                    >
                      <div className="d-flex justify-content-center align-items-center text-white gap-2">
                        {t("PaymentMethodSelection.ProceedToPayment")}

                        <ArrowRightIcon color="white" size={15} />
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* MOBILE */}
        <div className="d-block d-md-none">
          <div
            className={`modal fade ${show ? "show d-block" : ""}`}
            tabIndex="-1"
            style={show ? { backgroundColor: "rgba(0, 0, 0, 0.5)" } : {}}
            aria-labelledby="sharedModalLabel"
            aria-hidden={!show}
          >
            <div
              className={`modal-dialog modal-fullscreen ${centered ? "modal-dialog-centered" : ""
                }`}
            >
              <div className="modal-content">
                <div
                  className="
                p-3 bg-F6F6F6"
                >
                  <div className="d-flex align-items-center justify-content-between mt-3">
                    <div className="d-column">
                      <div
                        className="d-flex align-items-center mb-1 gap-2"
                        onClick={onClose}
                      >
                        <BackAltIcon />
                        <p className="m-0 noto">{t("Back")}</p>
                      </div>
                      <h4 className="m-0">{title}</h4>
                    </div>

                    <LanguageCard />
                  </div>
                </div>

                <div
                  className="d-flex flex-column px-3"
                  style={{ height: "calc(100vh - 99.59px)" }}
                >
                  {/* Scrollable content */}
                  <div className="overflow-auto p-2">
                    {paymentMethods != null && paymentMethods.length > 0 ? (
                      paymentMethods.map((item, index) => (
                        <div
                          className="p-3 rounded bg-F6F6F6 border-bottom-DBBE78 mb-3 pointer"
                          onClick={() => handleSelectedPaymentMethod(item._id)}
                        >
                          <div className="d-flex gap-2 align-items-center justify-content-start">
                            {selectedPaymentMethod === item._id
                              ? <RadioSelectedIcon />
                              : <RadioUnselectedIcon />}
                            <img
                              src={getCardTypeByBrand(item.brand)}
                              alt=""
                              srcSet=""
                            />
                            <p className="m-0">
                              •••• {item.cardNumber}, Exp.: {item.expirationMonth}/{item.expirationYear}
                            </p>
                            <CloseIcon
                              color="#666666"
                              size={10}
                              className="ms-auto pointer"
                              onClick={() => openShowModalDeleteConfirmation(item._id)}
                            />
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="mb-3">
                        {t("PaymentMethodSelection.NoPayment")}
                      </p>
                    )}
                    <div className="d-grid">
                      <button
                        className="btn bg-gold-light-100 rounded py-2"
                        onClick={addPaymentMethodHandler}
                      >
                        <div className="d-flex justify-content-center align-items-center gap-2">
                          {t("PaymentMethodSelection.AddPayment")}
                        </div>
                      </button>
                    </div>
                  </div>

                  <div className="p-4 mt-auto">
                    <div className="d-grid">
                      <button
                        className="btn bg-gold text-white rounded py-2"
                        onClick={() => {
                          if (
                            paymentMethods != null &&
                            paymentMethods.length > 0 &&
                            selectedPaymentMethod != null
                          ) {
                            payButtonAuthenticatedUser();
                          }
                        }}
                        disabled={
                          paymentMethods == null ||
                          paymentMethods.length < 1 ||
                          selectedPaymentMethod == null
                        }
                      >
                        <div className="d-flex justify-content-center align-items-center text-white gap-2">
                          {t("PaymentMethodSelection.ProceedToPayment")}
                          <ArrowRightIcon color="white" size={15} />
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>}
      <ConfirmationModal
        show={showDeleteConfirmation}
        title={t("PaymentMethodSelection.DeletePaymentMethod")}
        variant="danger"
        confirmLabel={t("PaymentMethodSelection.DeletePaymentMethod.Remove")}
        cancelLabel={t("PaymentMethodSelection.DeletePaymentMethod.Cancel")}
        onCancel={() => setShowDeleteConfirmation(false)}
        onConfirm={handleDeletePaymentMethod}
      />
    </>
  );
};

export default PaymentMethodSelectionModal;
